<template lang="pug">
yz-dialog(v-if="showDialog" v-model="showDialog" persistent scrollable width="440")
  yz-card
    yz-dialog-normal-header(title="Base UOM Changed" @close="onCancel")
    yz-dialog-normal-content
      div.yz-regular-body-sm.text-neutral-700.mt-4 This item was recorded with base UOM "{{ stockUom }}", but the current base UOM is "{{ inventoryUom }}".
      div.yz-regular-body-sm.text-neutral-500.mt-2 Stock return calculation cannot be performed due to the change in base UOM.
      div.yz-regular-body-sm.text-neutral-500.mt-1 Please delete this item and add it again to proceed with the correct conversion.
      yz-card.mt-3.pa-3(outlined color="red-100" border-color="red-100")
        div.yz-regular-body-sm.danger500--text You will need to adjust the stock manually in the stock action page.
    yz-dialog-normal-actions(save-label="Delete Item" cancel-label="Cancel" save-action-color="danger" @save="onConfirm" @cancel="onCancel")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
    },
    inventoryUom: {
      type: String,
      default: null
    },
    stockUom: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
      this.showDialog = false
    },
    onConfirm () {
      this.$emit('confirm')
      this.showDialog = false
    }
  },
}
</script>
